import { createContext } from 'utils/react-helpers';

const [ClientTravelDetailProvider, useClientTravelDetail] = createContext(
  'ClientTravelDetailContext',
);

export { ClientTravelDetailProvider, useClientTravelDetail };
